import { MessageBack, MessageFront } from '@entities/Message/types';
import { parseUTCDate } from '@root/src/utils/formatters/dates';

export const messageFromBack = ({ _id, createdAt, updatedAt, readBy, ...rest }: MessageBack): MessageFront => ({
  id: _id,
  createdAt: createdAt ? parseUTCDate(createdAt) : new Date(0),
  updatedAt: updatedAt ? parseUTCDate(updatedAt) : new Date(0),
  readBy:
    readBy && typeof readBy === 'object'
      ? Object.fromEntries(
          Object.entries(readBy).map(([user, timestamp]) => [
            user,
            // Keep null for participants who haven't read the message; collapsing it to a
            // Date (e.g. epoch) would make every recipient look like they have "seen" it.
            timestamp && typeof timestamp === 'string' ? parseUTCDate(timestamp) : null,
          ]),
        )
      : {},
  ...rest,
});
